export default __webpack_public_path__ + "static/media/corona_showdown.8aa4995c.gif";